import React from "react";
import { withStyles } from "@material-ui/styles";

import Button from "@material-ui/core/Button";

import colors from "../../assets/style/colors";

const styles = {
  root: {
    height: "36px",
    marginTop: "0px",
    marginBottom: "0px",
  },
  contained: {
    boxShadow: `0px 2px 2px 0px ${colors.black24}, 0px 0px 2px 0px ${colors.black12}`,
  },
  disabled: {
    color: `${colors.black38} !important`,
  },
  label: {
    lineHeight: "11px",
  },
};

const CustomButton = (props) => {
  const { classes } = props;

  return (
    <Button
      classes={{
        contained: classes.contained,
        disabled: classes.disabled,
        label: classes.label,
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default withStyles(styles)(CustomButton);
